import React, { useState, useRef } from 'react';

import Header from './Header';
import Disclaimers from './Disclaimers';

import { makeStyles } from '@material-ui/core';
import { Typography, Grid, CardActions, CardContent, TextField, Divider, Checkbox, Select, FormControl, InputLabel, MenuItem, FormControlLabel, Link, Button } from '@material-ui/core';

import { pronouns } from './pronouns';

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
        padding: 20,
        paddingTop: 100,
        margin: 'auto',
        maxWidth: 800,
    },
    formCard: {
        padding: theme.spacing(2),
        textAlign: 'left',
        color: theme.palette.text.secondary,
        //margin: theme.spacing(2),
        alignItems: 'center',
    },
    card: {
        //padding: theme.spacing(2),
        textAlign: 'center',
        color: theme.palette.text.secondary,
        //margin: theme.spacing(2),
        alignItems: 'center',
    },
    button: {
        padding: theme.spacing(2),
        //margin: theme.spacing(1),
        alignItems: 'center',
        //width: 150,
    },
    cardContent: {
        paddingTop: theme.spacing(1),
        paddintBottom: theme.spacing(1),
        paddingRight: theme.spacing(1),
        paddingLeft: theme.spacing(1),
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2),
        marginLeft: theme.spacing(0),
        marginRight: theme.spacing(0),
    },
    cardAction: {
        justifyContent: 'center',
        alignItems: 'center',
        paddingTop: theme.spacing(1),
        paddingBottom: theme.spacing(1),
        paddingRight: theme.spacing(1),
        paddingLeft: theme.spacing(1),
        margin: theme.spacing(0),
    },
    cardActionForm: {
        justifyContent: 'left',
        //display:'flex',
        //flexGrow:1, 
        paddingTop: theme.spacing(1),
        paddingBottom: theme.spacing(1),
        paddingRight: theme.spacing(1),
        paddingLeft: theme.spacing(1),
        margin: theme.spacing(0),
    },
    cardActionButton: {
        justifyContent: 'center',
        alignItems: 'center',
        paddingTop: theme.spacing(0),
        paddingBottom: theme.spacing(1),
        paddingRight: theme.spacing(1),
        paddingLeft: theme.spacing(1),
        margin: theme.spacing(0),
    },
    media: {
        //width: 100,
        //marginBottom: theme.spacing(4),
    },
    textField: {
        //textAlign: 'right',
        //marginRight:theme.spacing(1),
        //marginLeft: 4,
        marginRight: 10,
        width: 300,
    },
    textForm: {
        textAlign: "left",
        //flexGrow: 1,
        //marginLeft:theme.spacing(1),
        //padding: theme.spacing(2),
        //margin: theme.spacing(2),
    },
    textList: {
        textAlign: "right",
    },
    text: {
        textAlign: "center",
        //padding: theme.spacing(2),
        //margin: theme.spacing(2),
    },
    textExplanation: {
        textAlign: "justify",
        //padding: theme.spacing(2),
        //margin: theme.spacing(2),
    },
    select: {
        minWidth: 250,
    },
    checkbox: {

    },
    hiddenTextView: {
        display: 'none',
    }
}));

function TransTextField(props) {
    const classes = useStyles();

    return <TextField className={classes.textField} variant="standard" type="text" InputLabelProps={{ shrink: true }} placeholder="First Name" {...props} />
}

function TransCheckBox(props) {
    const classes = useStyles();
    //return <Checkbox className={classes.checkbox} inputProps={{ 'aria-label': 'primary checkbox' }} {...props} />
    return <FormControlLabel
        control={<Checkbox className={classes.checkbox} inputProps={{ 'aria-label': 'primary checkbox' }} {...props} />}
        label={props.text} />
}

export default function TransLetter(props) {

    const surgeon = "[Surgeon]";
    const client = "[Client]";
    const dateOfBirth = "[Date of Birth]";
    const [title, setTitle] = useState("mental health clinician");
    const [surgery, setSurgery] = useState("gender confirming surgery");
    const [selectedPronouns, setSelectedPronouns] = useState(pronouns[0]); //default she/hers using pronouns array
    const [gender, setGender] = useState("female");
    const [hrtChecked, setHrtChecked] = useState(true);
    const [timeOnHrt, setTimeOnHrt] = useState("over 1 year");
    const [showWPath, setShowWPath] = useState(true);
    const [showLegalNameChange, setshowLegalNameChange] = useState(true);
    const [showLegalGenderChange, setShowLegalGenderChange] = useState(true);
    const [showFunctionalInterference, setShowFunctionalInterference] = useState(true);

    const textAreaRef = useRef(null); // Reference for text area

    function handleSurgeryFieldValueChanged(event) {
        setSurgery(event.target.value);
    }

    function handleTitleFieldValueChanged(event) {
        setTitle(event.target.value);
    }

    function handlePronounChoiceValueChanged(event) { //confirm how the value is sent, want int not text
        setSelectedPronouns(event.target.value);
    }

    function handleGenderFieldValueChanged(event) {
        setGender(event.target.value);
    }

    function handleHrtCheckboxClicked() {
        setHrtChecked(!hrtChecked);
    }

    function handleTimeOnHrtFieldValueChanged(event) {
        setTimeOnHrt(event.target.value);
    }

    function handleShowWpathCheckboxClicked() {
        setShowWPath(!showWPath);
    }

    function handleLegalNameChangeCheckboxClicked() {
        setshowLegalNameChange(!showLegalNameChange);
    }

    function handleLegalGenderChangeCheckboxClicked() {
        setShowLegalGenderChange(!showLegalGenderChange);
    }

    function handleShowFunctionalInterferenceCheckboxClicked() {
        setShowFunctionalInterference(!showFunctionalInterference);
    }

    // Creating custom inputs for readability
    function surgeryTypeTextField() {
        return <TransTextField id="surgery_type" label="Surgery Type" placeholder="Surgery Type" value={surgery} onChange={handleSurgeryFieldValueChanged} />;
    }

    function titleTextField() {
        return <TransTextField id="title" label="Clinician Title (i.e. Psychiatrist, Social Worker)" placeholder="Clinical Title" value={title} onChange={handleTitleFieldValueChanged} />;
    }

    function genderTextField() {
        return <TransTextField id="gender" label="Client's Identified Gender" placeholder="Gender" value={gender} onChange={handleGenderFieldValueChanged} />;
    }

    function hrtCheckbox() {
        return <TransCheckBox checked={hrtChecked} onChange={handleHrtCheckboxClicked} text="on hormones?" />;
    }

    function timeOnHrtTextField() {
        return <TransTextField id="time-on-hrt" label="Time On HRT" placeholder="Time On HRT" value={timeOnHrt} onChange={handleTimeOnHrtFieldValueChanged} />;
    }

    function wPathCheckbox() {
        return <TransCheckBox checked={showWPath} onChange={handleShowWpathCheckboxClicked} text="Show WPATH sentence?" />;
    }

    function legalNameChangeCheckbox() {
        return <TransCheckBox checked={showLegalNameChange} onChange={handleLegalNameChangeCheckboxClicked} text="Legally changed name?" />;
    }

    function legalGenderChangeCheckbox() {
        return <TransCheckBox checked={showLegalGenderChange} onChange={handleLegalGenderChangeCheckboxClicked} text="Legally changed gender?" />;
    }

    function functionalInteferenceCheckbox() {
        return <TransCheckBox checked={showFunctionalInterference} onChange={handleShowFunctionalInterferenceCheckboxClicked} text="Has functional interference?" />;
    }

    const classes = useStyles();

    // Create text-only to copy and paste
    function displayText() {
        return `Dear Dr. ${surgeon},\n\n
        I am writing this letter on behalf of ${client}  (DOB: ${dateOfBirth}, pronouns: ${selectedPronouns.title.toLowerCase()}). It is my understanding that ${client} recently consulted with you regarding ${surgery}.\n
        I am a ${title} who has worked with ${client} on a regular basis in my clinic. I have had the opportunity to get to know ${client} in this setting and feel comfortable speaking on ${selectedPronouns.object} behalf.\n
        For over a year ${selectedPronouns.possesiveHas} never presented ${selectedPronouns.self} as having any other identity other than ${gender}. ${hrtChecked ? `${client} has been on hormone replacement therapy for ${timeOnHrt}.` : null} ${client} lives ${selectedPronouns.object} life fully and openly in this role ${showLegalNameChange ? `, including legally changing ${selectedPronouns.object} name and documentation to the extent allowable by state and federal guidelines.` : null}\n
        From a mental health clinical standpoint, I see no valid reason to deny ${client}'s request for ${surgery} or delay pending further evaluation. ${client} meets criteria for gender dysphoria as defined in the ICD-10/DSM-5 (F64.0). The dysphoria that ${client} currently experiences arises from the incongruence between ${selectedPronouns.object} body and ${selectedPronouns.object} gender identity. This results in significant discomfort with ${selectedPronouns.object} misaligned body, not on an internal sense of conflict or ambivalence regarding ${selectedPronouns.object} identity. ${showFunctionalInterference ? `This distress causes ${client} to experience functional interference with ${selectedPronouns.object} ability to engage in social and interpersonal relationships and activities in a manner that would be expected of any other person at ${selectedPronouns.object} education and position.` : null} Rectifying ${selectedPronouns.object} body incongruence is reasonably expected to provide marked relief for the anxiety and distress that ${client} experiences, thereby allowing ${selectedPronouns.possesive} to live a fully functional and meaningful life in society without further impairment. ${client} has no psychiatric co-morbidity that would preclude ${selectedPronouns.possesive} from giving informed consent for ${surgery}.\n
        ${client} is seeking ${surgery} at this time because it is now feasible both financially and interpersonally. ${showWPath ? `To my knowledge, ${selectedPronouns.subject} has met the requirements for the WPATH Standards of Care, and should be afforded this opportunity to physically align with ${selectedPronouns.object} well-established gender identity.` : null} ${showLegalGenderChange ? `For all legal intent and purposes, ${client} is now viewed as ${gender}.` : null}\n\n
        Sincerely, `;
    }

    function copyToClipboard(event) {
        event.preventDefault();
        textAreaRef.current.select();
        document.execCommand('copy');
        alert(`Copied text to clipboard...`);
    }

    return <>
        <div className={classes.root}>
            <Header title={"Gender Confirming Surgery Letter"} subTitle={"Starting point for mental health letters supporting gender affirming/confirming surgeries."} />
            <Grid container spacing={3}>
                <Grid item xs={12}>
                    <CardContent className={classes.cardContent}>
                        <Typography className={classes.textExplanation} color="inherit" variant="body1">
                            <strong>Please Read Before Proceeding:</strong> The following template is intended as a <em>starting point</em> for writing a mental health letter in support of gender affirming surgery. It is an example. You bear the responsibility to check in your particular region of clinical practice for any required or recommended training and wording needed for your particular professional practice and liability. </Typography>
                        <br />
                        <Typography className={classes.textExplanation} color="inherit" variant="body1">
                            <strong>This site does not promise that use of this letter template will result in surgical authorizations or access and can assume no liability for any letter written based on this template for any patient seeking gender affirming medical care.</strong> Mental health professionals using this template do so at their own risk. You will likely need to customize this letter.</Typography>
                        <br />
                        <Typography className={classes.textExplanation} color="inherit" variant="body1">It is recommended that you familiarize yourself with the <Link onClick={(e) => e.preventDefault} href="https://www.wpath.org/media/cms/Documents/SOC%20v7/SOC%20V7_English2012.pdf?_t=1613669341" target="_blank">World Professional Association for Transgender Health (WPATH) Standards of care, version 7</Link> and the sections in that protocol that pertain to assessment and referrals for gender confirming surgeries. </Typography>
                        <br />
                        <Typography className={classes.textExplanation} color="inherit" variant="body1">This site does not endorse or imply that any particular pathway to gender affirmation applies to all or even most people who experience gender dysphoria.</Typography>
                        <br />
                        <Typography className={classes.textExplanation} color="inherit" variant="body1">The template below is <em>based</em> on the sample letters included in <Link onClick={(e) => e.preventDefault} href="https://fenwayhealth.org/care/medical/transgender-health/" target="_blank">Fenway Health's Transgender Site</Link> (other examples can be seen under "Provider Support"). This is a great resource for education on gender affirming surgeries and the clinician's role in these assessments.</Typography>
                        <br /><br />
                        <Typography className={classes.textExplanation} color="inherit" variant="caption">
                            <em>Please Note:</em> Data is processed directly in the browser and no data is stored or sent to outside third-party services. For further protection of privacy, we use the generic "<strong>[Client]</strong>" instead of the client name. Once you copy and paste the draft to a word processing document (with letterhead), we recommend using Ctrl+F (PC) or ⌘+F (Mac) and choose "Find and Replace" -{`>`} "[Client]" with the client's first name. Make sure to include the full name, aka name (if applicable), and date of birth in the first sentence. Also replace "[Surgeon]" with the surgeon's name for further personalization of letter.
                        </Typography>
                    </CardContent>
                    <Divider />
                    <CardActions className={classes.cardActionForm}>
                        <form>
                            <br/><br/>
                            <Typography variant="h5">Personalized Options</Typography>
                            <br/>
                            {titleTextField()}
                            <br /><br />
                            <FormControl className={classes.select} htmlFor="pronouns">
                                <InputLabel id="pronoun-pick">Client's Preferred Pronouns</InputLabel>
                                <Select labelId="pronoun-pick-select" labelWidth={100} id="pronoun-pick-select" label="Pronouns" value={selectedPronouns} onChange={handlePronounChoiceValueChanged}>
                                    {pronouns.map((pronoun) => <MenuItem key={pronoun.title} value={pronoun}>{pronoun.title}</MenuItem>)}
                                </Select>
                            </FormControl>
                            <br /><br />
                            {genderTextField()}
                            <br /><br />
                            {surgeryTypeTextField()}
                            <br /><br />
                            {hrtCheckbox()}  {hrtChecked ? <React.Fragment>Client has been on HRT for: {timeOnHrtTextField()}</React.Fragment> : null}
                            <br /><br />
                            {functionalInteferenceCheckbox()} {showFunctionalInterference ? <React.Fragment>Client has evidence of functional interference...</React.Fragment> : null}
                            <br /><br />
                            {legalNameChangeCheckbox()} {showLegalNameChange ? <React.Fragment>Client has legally changed name...</React.Fragment> : null}
                            <br /><br />
                            {legalGenderChangeCheckbox()} {showLegalGenderChange ? <React.Fragment>Client has legally changed gender...</React.Fragment> : null}
                            <br /><br />
                            {wPathCheckbox()}  {showWPath ? <React.Fragment>Client has met the requirements for the WPATH Standards of Care...</React.Fragment> : null}
                            <br /><br />
                            <Divider />
                            <br /><br />
                            <Typography variant="h5">Letter Draft</Typography>
                            <br/>
                            <Typography className={classes.textExplanation} variant="body1"> Dear Dr. <strong>{surgeon}</strong>,</Typography>
                            <br />
                            <Typography className={classes.textExplanation} variant="body1">I am writing this letter on behalf of <strong>{client} </strong> (DOB: <strong>{dateOfBirth}</strong>, pronouns: <strong>{selectedPronouns.title.toLowerCase()}</strong>). It is my understanding that <strong>{client}</strong> recently consulted with you regarding <strong>{surgery}</strong>.</Typography>
                            <br />
                            <Typography className={classes.textExplanation} variant="body1">I am a <strong>{title}</strong> who has worked with <strong>{client}</strong> on a regular basis in my clinic. I have had the opportunity to get to know <strong>{client}</strong> in this setting and feel comfortable speaking on <strong>{selectedPronouns.object}</strong> behalf.</Typography>
                            <br />
                            <Typography className={classes.textExplanation} variant="body1">For over a year <strong>{selectedPronouns.possesiveHas}</strong> never presented <strong>{selectedPronouns.self}</strong> as having any other identity other than <strong>{gender}</strong>. {hrtChecked ? <React.Fragment><strong>{client}</strong> has been on hormone replacement therapy for <strong>{timeOnHrt}</strong>.</React.Fragment> : null} <strong>{client}</strong> lives <strong>{selectedPronouns.object}</strong> life fully and openly in this role{showLegalNameChange ? <React.Fragment>, including legally changing <strong>{selectedPronouns.object}</strong> name and documentation to the extent allowable by state and federal guidelines.</React.Fragment> : null}</Typography>
                            <br />
                            <Typography className={classes.textExplanation}>From a mental health clinical standpoint, I see no valid reason to deny <strong>{client}'s</strong> request for <strong>{surgery}</strong> or delay pending further evaluation. <strong>{client}</strong> meets criteria for gender dysphoria as defined in the ICD-10/DSM-5 (F64.0). The dysphoria that <strong>{client}</strong> currently experiences arises from the incongruence between <strong>{selectedPronouns.object}</strong> body and <strong>{selectedPronouns.object}</strong> gender identity. This results in significant discomfort with <strong>{selectedPronouns.object}</strong> misaligned body, not on an internal sense of conflict or ambivalence regarding <strong>{selectedPronouns.object}</strong> identity. {showFunctionalInterference ? <React.Fragment>This distress causes <strong>{client}</strong> to experience functional interference with <strong>{selectedPronouns.object}</strong> ability to engage in social and interpersonal relationships and activities in a manner that would be expected of any other person at <strong>{selectedPronouns.object}</strong> education and position.</React.Fragment> : null} Rectifying <strong>{selectedPronouns.object}</strong> body incongruence is reasonably expected to provide marked relief for the anxiety and distress that <strong>{client}</strong> experiences, thereby allowing <strong>{selectedPronouns.possesive}</strong> to live a fully functional and meaningful life in society without further impairment. <strong>{client}</strong> has no psychiatric co-morbidity that would preclude <strong>{selectedPronouns.possesive}</strong> from giving informed consent for <strong>{surgery}</strong>.</Typography>
                            <br />
                            <Typography className={classes.textExplanation} variant="body1"><strong>{client}</strong> is seeking {surgery} at this time because it is now feasible both financially and interpersonally. {showWPath ? <React.Fragment>To my knowledge, <strong>{selectedPronouns.subject}</strong> has met the requirements for the WPATH Standards of Care, and should be afforded this opportunity to physically align with <strong>{selectedPronouns.object}</strong> well-established gender identity.</React.Fragment> : null} {showLegalGenderChange ? <React.Fragment>For all legal intent and purposes, <strong>{client}</strong> is now viewed as <strong>{gender}</strong>.</React.Fragment> : null}</Typography>
                            <br />
                            <Typography className={classes.textExplanation} variant="body1">Sincerely, ...</Typography>
                            <br /><br />
                            <Divider/>
                            <br /><br />
                            <Button className={classes.button} id="copy-text" variant="contained" size="medium" onClick={copyToClipboard} color="primary">Copy To Clipboard</Button>
                            <br /><br />
                            <Typography variant="h5">Editable Text</Typography>
                            <br />
                            <TextField multiline id="clipboardText" value={displayText()} inputRef={textAreaRef} variant="outlined" fullWidth onClick={() => textAreaRef.current.select()} />
                            <br /><br />
                        </form>
                    </CardActions>
                </Grid>
            </Grid>
            <Divider />
            <Disclaimers />
        </div>
    </>;
}
